import { vehicleListingStore } from '@/models/stores';

const useVehicleListing = (id: string) => {
  const vehicleListing = vehicleListingStore.getById(id);

  return { vehicleListing };
};

export default useVehicleListing;
